import Field from '@base/Form/Field';
import {
  Error,
  FieldWrapper,
  FieldWrapperFlex,
  FormContainer,
  StyledTextField,
  StyledTextFieldFlex
} from './styles';
import {
  checkAlphabetic,
  isLengthMatchError,
  isRequired,
  checkNumberic
} from './utils';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const AddressDetails = ({
  registrar,
  localAddress,
  isLocalAddressSame,
  updateStoreData,
  setIsPincodeUpdated,
  setIsLocalPincodeUpdated
}) => {
  const { data } = registrar;
  const { addressLine1, addressLine2, pincode, city, state } = data;
  return (
    <FormContainer>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name={localAddress ? 'localAddressLine1' : 'addressLine1'}
          rules={localAddress ? [] : [isRequired('Enter address line 1')]}
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Address line 1"
              value={isLocalAddressSame ? addressLine1 : value}
              onChange={(fieldData) => {
                onChange(fieldData.target.value);
                updateStoreData(
                  localAddress ? 'localAddressLine1' : 'addressLine1',
                  fieldData.target.value
                );
              }}
              error={hasError}
              disabled={isLocalAddressSame}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name={localAddress ? 'localAddressLine2' : 'addressLine2'}
          rules={localAddress ? [] : [isRequired('Enter address line 2')]}
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Address line 2"
              value={isLocalAddressSame ? addressLine2 : value}
              onChange={(fieldData) => {
                onChange(fieldData.target.value);
                updateStoreData(
                  localAddress ? 'localAddressLine2' : 'addressLine2',
                  fieldData.target.value
                );
              }}
              error={hasError}
              disabled={isLocalAddressSame}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name={localAddress ? 'localPincode' : 'pincode'}
          rules={
            localAddress
              ? []
              : [
                  isRequired('Pincode is required'),
                  isLengthMatchError('Enter a valid pincode', 6)
                ]
          }
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Pincode"
              value={isLocalAddressSame ? pincode : value}
              onChange={(d) => {
                if (checkNumberic(onChange, d)) {
                  updateStoreData(
                    localAddress ? 'localPincode' : 'pincode',
                    d.target.value
                  );
                  if (localAddress) setIsLocalPincodeUpdated(true);
                  else {
                    setIsPincodeUpdated(true);
                  }
                }
              }}
              error={hasError}
              disabled={isLocalAddressSame}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapperFlex>
        <FieldWrapper>
          <Field
            registrar={registrar}
            name={localAddress ? 'localCity' : 'city'}
            rules={localAddress ? [] : [isRequired('City is required')]}
            render={({ onChange, value, hasError }) => (
              <StyledTextFieldFlex
                placeholder="City"
                value={isLocalAddressSame ? city : value}
                onChange={(fielddata) => {
                  if (checkAlphabetic(onChange, fielddata)) {
                    updateStoreData(
                      localAddress ? 'localCity' : 'city',
                      fielddata.target.value
                    );
                  }
                }}
                error={hasError}
                disabled={isLocalAddressSame}
              />
            )}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            registrar={registrar}
            name={localAddress ? 'localState' : 'state'}
            rules={localAddress ? [] : [isRequired('State is required')]}
            render={({ onChange, value, hasError }) => (
              <StyledTextFieldFlex
                placeholder="State"
                value={isLocalAddressSame ? state : value}
                onChange={(fielddata) => {
                  if (checkAlphabetic(onChange, fielddata)) {
                    updateStoreData(
                      localAddress ? 'localState' : 'state',
                      fielddata.target.value
                    );
                  }
                }}
                error={hasError}
                disabled={isLocalAddressSame}
              />
            )}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>
      </FieldWrapperFlex>
    </FormContainer>
  );
};

export default AddressDetails;
